export const MAX_RANDOM_SHIFT = 24;

export function getRandomMargin() {
  return Math.floor(Math.random() * (MAX_RANDOM_SHIFT + 1));
}
